import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import ModalPasswordInput from '../../components/Modals/ModalInputs/ModalPasswordInput';
import API from '../../utils/API'
import constants from '../../utils/constants'
import { setUserState } from '../../store/user'
import { identifyUser } from '../../utils/analytics'

function Login(props) {
  const navigate = useNavigate();
  const [state, setState] = useState({
    email: '',
    password: ''
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');

  function handleChange(event) {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setState({
      ...state,
      [event.target.name]: value
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    API.login({
      email: state.email,
      password: state.password
    })
    .then(() => {
      API.authenticate()
        .then(res => {
        // Update user store after successful login
        props.dispatch(setUserState(res.data.user));

        // Identify user in PostHog (using numeric ID only, no PII)
        const user = res.data.user;
        if (user && user.id) {
          identifyUser(user.id, {
            account_id: user.account?.id,
            user_roles: user.roles?.map(role => role.name || role.id) || []
          });
        }

        const urlParams = new URLSearchParams(window.location.search);
        const backUrl = urlParams.get('back_url');

        if(backUrl === 'browsercast'){
          if(window.location.hostname.includes('dev')){
            window.location.href = 'https://dev.screenbeam.me/moderate';
          } else if (window.location.hostname.includes('staging2')){
            window.location = 'https://staging2.screenbeam.me/moderate';
          } else if (window.location.hostname.includes('staging')){
            window.location = 'https://staging.screenbeam.me/moderate'
          } else {
            window.location = 'https://screenbeam.me/moderate';
          }
        } else {
          // Send user to home page
          window.location = '/';
        }

        // NOTE 8/9: Redirect user based on permissions after login
        // redirectUser(res.data.user.permissions);
      })
    }).catch(err => {
      // Error message handling
      console.log(err);
      switch (err.message.slice(-3)) {
        case "400":
          setError(<FormattedMessage id="INVALID_PARAMETERS" />);
          break;
        case "401":
          setError(<FormattedMessage id="INCORRECT_USERNAME_PASSWORD_ROLES" />);
          break;
        case "500":
        case "504":
          setError(<FormattedMessage id="SERVER_ERROR" />);
          break;
        default:
          setError(err.message);
      }
    });
  }

  return (
    <div className='login container'>
      <div className='row justify-content-center p-3'>
        <div className='col-5'>
          <form onSubmit={handleSubmit}>
            <div className='header text-center mb-4'>
              <h2><FormattedMessage id="SCREENBEAM_CLOUD" /></h2>
            </div>
            <div className='card'>
              <div className='form-group mb-4'>
                <label className='form-label' htmlFor='email'><FormattedMessage id="EMAIL_ADDRESS" /></label>
                <input 
                  id='email'
                  onChange={handleChange} 
                  value={state.email} 
                  name='email' 
                  type='email' 
                  className='form-control' 
                />
              </div>
              <div className='form-group'>
                <label className='form-label' htmlFor='password'><FormattedMessage id="PASSWORD" /></label>
                <ModalPasswordInput 
                  id="password"
                  onChange={handleChange} 
                  value={state.password} 
                  name="password"
                  className="form-control"
                />
              </div>
              <div className='row'>
                <div className={'col me-auto password-btn text-start ' + (error ? 'mb-3' : 'mb-5')}>
                  <a href='../resend-verification-email'><FormattedMessage id="RESEND_VERIFICATION_EMAIL" /></a>
                </div>
                <div className={'col password-btn text-end ' + (error ? 'mb-3' : 'mb-5')}>
                  <a href='../forgot-password'><FormattedMessage id="FORGOT_PASSWORD" /></a>
                </div>
              </div>
              {error ? <p className='error'>{error}</p> : null}
              <button id="loginBtn" type='submit' className='btn btn-primary btn-block' onClick={handleSubmit}><FormattedMessage id="LOG_IN" /></button>
              {/* <div className='register-btn row text-center mb-2'>
                <a href='../registration'>Register</a>
              </div> */}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(Login);
